export default "__VITE_ASSET__551f8e1e__"